var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('img',{attrs:{"src":_vm.iconType,"alt":_vm.type},on:{"click":_vm.action}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }